"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var acceptSharedCalendarInvite_1 = require("../services/acceptSharedCalendarInvite");
var selectNewCalendar_1 = require("../services/selectNewCalendar");
var acceptInvite = legacy_1.action('acceptInvite')(function acceptInvite(sharingInviteItemId) {
    return acceptSharedCalendarInvite_1.default(sharingInviteItemId).then(function (response) {
        if (response.ResponseClass == 'Success' && response.NewCalendarEntryId) {
            // select the new calendar
            selectNewCalendar_1.default(response.NewCalendarEntryId.Id);
        }
        return new Promise(function (resolve) {
            resolve(response.ResponseClass == 'Success');
        });
    });
});
exports.default = acceptInvite;
//# sourceMappingURL=acceptInvite.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-sharing-accept/lib/actions/acceptInvite.js
// module id = 5804
// module chunks = 96